import axios from "axios";

const getErecete = async (baseUrl, token, doctorId, appointmentId, patientId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + `/doctor/`+ doctorId+ "/appointment/" + appointmentId+ "/e-prescription/" + patientId, config)
        .then((res) => {
            getResponse = {
                status: res.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return getResponse
}

export default getErecete;

//{{uri}}/doctor/{{doctorid}}/appointment/96/e-prescription/1038